import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CategoryMaintenanceComponent } from './category-maintenance.component';

const routes: Routes = [
  {
    path:'',
    component: CategoryMaintenanceComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CategoryMaintenanceRoutingModule { }
